import { RefObject, useEffect, useState } from 'react';

export const useHorizontalScroll = (viewportRef: RefObject<HTMLElement>) => {
  const [showLeftScrollButton, setShowLeftScrollButton] =
    useState<boolean>(false);
  const [showRightScrollButton, setShowRightScrollButton] =
    useState<boolean>(false);

  const updateButtonVisibility = () => {
    if (viewportRef.current) {
      const { scrollLeft, scrollWidth, clientWidth } = viewportRef.current;
      setShowLeftScrollButton(scrollLeft > 0);
      setShowRightScrollButton(scrollLeft < scrollWidth - clientWidth);
    }
  };

  useEffect(() => {
    updateButtonVisibility(); // Check on mount

    // Optionally, handle resize for dynamic content or container sizes
    window.addEventListener('resize', updateButtonVisibility);
    return () => window.removeEventListener('resize', updateButtonVisibility);
  }, []);

  const handleScroll = (scrollAmount: number) => {
    if (!viewportRef || !viewportRef.current) {
      return;
    }
    viewportRef.current.scrollLeft += scrollAmount;
    updateButtonVisibility();
  };

  return { handleScroll, showLeftScrollButton, showRightScrollButton };
};
